module.exports = __webpack_public_path__ + "img/shuzhimendian.jpg";